<re-alert *ngIf="alert" [type]="alert.type" (close)="alert = null">{{ alert.message }}</re-alert>

<h1>Import Users </h1>

<!-- Keycloak to IDM Coversion Form -->
<form class="mt-3" role="form" novalidate #form="ngForm" method="post" (ngSubmit)="run()">
    <!-- Customer, Env and Corporation row -->
    <div class="row">
        <div class="col-md-4 col-xs-1">
            <div class="form-group input-required">
                <label for="customer">Customer</label>
                <select2 required [settings]="{ placeholder: 'Not Selected', width: '100%' }" id="customer"
                    name="customer" [options]="customers" [(ngModel)]="customer" (onSelect)="customerChanged($event)">
                </select2>
            </div>
        </div>

        <!-- <div class="col-md-4 col-xs-1">
            <div class="form-group input-required">
                <label for="environment">Environment</label>
                <select2 required [settings]="{ placeholder: 'Not Selected', width: '100%' }" id="environment"
                    name="environment" [options]="environments" [(ngModel)]="environment"
                    (onSelect)="environmentChanged($event)">
                </select2>
            </div>
        </div> -->
    </div>

    <!-- Checkbox row to include more users -->
    <div class="row">
        <div class="col-md-4 col-xs-1">
            <div class="form-group input-required">
                <label for="source">Source</label>
                <br />
                <div class="mt-1 ml-3 form-check form-check-inline" *ngFor="let source of sources">
                    <input class="form-check-input" id="{{source.name}}" name="source" [(ngModel)]="selectedSource" value="{{source.name}}" type="radio" />
                    <label class="form-check-label" for="{{source.name}}">{{source.name}}</label>
                </div>
            </div>
        </div>
    </div>

    <!-- Checkbox row to include more users -->
    <!-- <div class="row">
        <div class="form-group">
            <div class="ml-3 form-check form-check-inline">
                <input class="form-check-input" id="updateExistingUsers" name="updateExistingUsers" type="checkbox" [(ngModel)]="updateExistingUsers" value="" />
                <label class=" mr-2 form-check-label" for="updateExistingUsers"> Update existing users  <small> (matching username) </small> </label>
            </div>
        </div>
    </div> -->

    <div class="row">
        <div class="col-md-4 col-xs-1" style="padding-left: 5px !important;">
            <div class="form-group col-12 input-required">
                <label for="domain">Domain</label>
                <br />
                <input required class="form-control" #domainControl="ngModel" [pattern]="domainRegExPattern" id="domain" name="domain" type="text" [(ngModel)]="domain" value="" />
                <p *ngIf="domain && domainControl.errors?.pattern" class="text-danger">
                    Please enter a valid domain name.
                </p>
            </div>
        </div>
    </div>

    <!-- Checkbox row to include more users -->
    <div class="row mt-4">
        <div class="col-12 col-sm-8 col-lg-6">
            <div class="mt-2">
                <a [routerLink]="[]" (click)="downloadSampleTemplate()">Click Here</a>
                <span> to download the standard user template file. </span>
            </div>
            <div class="mt-2">
                <a [routerLink]="[]" (click)="downloadPhysicianSampleTemplate()">Click Here</a>
                <span> to download the physician/NPPA user template file. </span>
            </div>
        </div>
    </div>

    <div class="row mt-4">
        <div class="col-12 col-sm-8 col-lg-4 my-3">
            <div class="form-group input-required">
                <input class="form-check-input" id="file" name="file" type="file" #file style="display: none;" (click)="file.value = null" (change)="onFileSelected()" />
                <button type="button" class="btn btn-primary" [disabled]="uploading" (click)="selectFile()">
                    Select File
                </button>
                <span class="ml-2">
                    {{fileName || "No file selected yet."}}
                </span>
            </div>
            <p *ngIf="selectedFile && form.control.errors?.invalidFileType" class="text-danger">
                Invalid file type. Please upload csv file.
            </p>
        </div>
    </div>

    <div class="row mt-3">
        <!-- Back button next to upload CSV -->
        <div class="ml-2 mr-2">
            <button type="button" class="btn btn-default" (click)="back()">
                Back
            </button>
        </div>
        <div class="ml-2 mr-2">
            <button type="button" class=" btn btn-primary" [disabled]="!selectedFile || form.control.errors?.invalidFileType || !form.valid || unfilteredData" (click)="parseCSV()">
                Upload CSV
            </button>
        </div>
    </div>

    <div  class="row mt-4" *ngIf="errorUserCount === 0">
        <div class="col-12">
            <!-- Show when no errors in CSV -->
            <span>Uploaded CSV has no errors. Please go ahead and import users to IDM using Import Users to IDM button.</span>
        </div>
    </div>

    <!-- Conversion Table -->
    <div *ngIf="unfilteredData">
        <div class="row mt-3">
          <div class="col-8">
            Pre Migration readiness for users in the list bellow ({{  numberOfErrors == 0   ? "no errors"  : numberOfErrors + " unresolved errors" }} out of {{ unfilteredData?.length }} users)
          </div>
        </div>
        <div class="row mt-1">
          <div class="col-md-8">
            <div class="progress">
              <div class="progress-bar" *ngIf="errorPercentage != 0" [style.width.%]="errorPercentage" role="progressbar" aria-valuenow="{{ errorPercentage }}" aria-valuemin="0" aria-valuemax="100">
                {{ errorPercentage | number }}%
              </div>
            </div>
          </div>
        </div>
    </div>

    <div class="row" [hidden]="!unfilteredData">
        <div class="col-12">
          <table class="table table-bordered table-striped table-fit" id="resultsDataTable"></table>
        </div>
    </div>

    <div>
        <div class="row mt-5">
            <div class="ml-2 mr-2" [hidden]="!unfilteredData">
                <!-- Export to CSV Button Below -->
                <span class="button-container"> </span>
            </div>
            <div class="ml-2 mr-2">
                <button (click)="import()" [disabled]="!importUsersValid" *ngIf="isImportUsers" type="button"  class="btn btn-primary">
                  Import Users to IDM
                </button>
            </div>
        </div>
    </div>
</form>
